import React from "react";
import Marquee from "react-fast-marquee";

interface RoomTagProps {
  text: string;
  showText: boolean;
  className?: string;
  icon?: React.ComponentType<{ className?: string }>;
  size?: "small" | "medium" | "large";
}

const RoomTag: React.FC<RoomTagProps> = ({ 
  text, 
  showText, 
  className = "",
  icon: CustomIcon,
  size = "medium"
}) => {
  if (!text || !showText) return null;

  // Size configurations
  const sizeConfig = {
    small: {
      container: "text-[10px] text-white bg-[#10B018] py-1 px-1 rounded-full text-center mx-2 flex-[1] h-[30px] min-w-[80px] max-w-[80px] flex justify-center items-center transition-all duration-300 cursor-pointer",
      iconSize: "w-3 h-3",
      textSize: "text-[10px]",
      scrollThreshold: 8
    },
    medium: {
      container: "text-md py-2 text-white rounded-full bg-[#10B018] justify-center text-center mr-4 min-w-[80px] ",
      iconSize: "w-4 h-4", 
      textSize: "text-md",
      scrollThreshold: 8
    },
    large: {
      container: "text-lg py-2 text-white rounded-full bg-[#10B018] justify-center text-center mr-4 min-w-[80px] ",
      iconSize: "w-6 h-6",
      textSize: "text-lg",
      scrollThreshold: 8
    }
  };

  const config = sizeConfig[size];
  const shouldScroll = text.length > config.scrollThreshold;


  return (
    <div className={`${config.container} ${className}`}>
      <div className="flex items-center w-full justify-center px-2 ">
        {CustomIcon && <CustomIcon className={`${config.iconSize} text-white mr-0.5 flex-shrink-0`} />}
        <div className="overflow-hidden flex-1 min-w-0">
          {shouldScroll ? (
            <Marquee play pauseOnHover gradient={false} speed={15} className={config.textSize}>
              <span className={`whitespace-nowrap ${config.textSize}`}>{text}&nbsp;&nbsp;&nbsp;</span>
            </Marquee>
          ) : (
            <span className={`whitespace-nowrap text-center block ${config.textSize}`}>{text}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoomTag;